import { useNavigate } from 'react-router-dom';
import Button from '../../../components/base/Button';

const FeaturedWork = () => {
  const featuredProjects = [
    {
      id: 'blue-prints-dodgers',
      title: 'Blue Prints x Los Angeles Dodgers',
      category: 'Brand Strategy & Photography',
      description: 'Strategic brand partnership intertwining Blue Prints photography services with the iconic Los Angeles Dodgers brand to create immersive fan experiences at Dodger Stadium.',
      image: 'https://static.readdy.ai/image/3fdc746f0d1d84f2cde4df046cd392e8/9680b691d39b1f97ff100a8468824092.jpeg',
      year: '2024'
    },
    {
      id: 'sports-camp',
      title: 'Sports Camp Photography for All Ages',
      category: 'Event Photography',
      description: 'Comprehensive documentation of a multi-sport youth camp with diverse participants across different age groups.',
      image: 'https://static.readdy.ai/image/3fdc746f0d1d84f2cde4df046cd392e8/01a2c8c01c4130c6ae24726c2e3d0e14.jpeg',
      year: '2024'
    },
    {
      id: 'yaamava-interactive-activation',
      title: 'Yaamava\' Resort & Casino Interactive Activation',
      category: 'Art Direction & Experience Design',
      description: 'Comprehensive art direction for Yaamava\' Resort & Casino\'s interactive brand activation, featuring custom photo experiences that blend entertainment, culture, and memorable guest engagement.',
      image: 'https://static.readdy.ai/image/3fdc746f0d1d84f2cde4df046cd392e8/4b4ce9610d8b4e8bd13be190ae261a70.jpeg',
      year: '2024'
    }
  ];

  const navigate = useNavigate();

  const handleProjectClick = (projectId: string) => {
    if (projectId === 'yaamava-interactive-activation') {
      navigate('/projects/yaamava-activation');
    } else if (projectId === 'blue-prints-dodgers') {
      navigate('/projects/blue-prints-dodgers');
    } else {
      navigate(`/work#${projectId}`);
    }
  };

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end mb-16">
          <div>
            <h2 className="text-4xl md:text-5xl font-light text-gray-900 mb-4">
              Selected work
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl leading-relaxed">
              Case studies showcasing the transformation of complex challenges into clear, impactful visual solutions.
            </p>
          </div>
          
          <Button href="/work" variant="ghost" className="mt-6 lg:mt-0 rounded-none">
            View All Projects
            <i className="ri-arrow-right-line ml-2"></i>
          </Button>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-8">
          {featuredProjects.map((project, index) => (
            <article 
              key={index} 
              className="group cursor-pointer"
              onClick={() => handleProjectClick(project.id)}
            >
              <div className="bg-white overflow-hidden transition-all duration-300 hover:shadow-lg">
                <div className="aspect-[3/2] overflow-hidden">
                  <img 
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                
                <div className="p-6">
                  <div className="flex justify-between items-start mb-3">
                    <span className="text-sm text-gray-500 uppercase tracking-wide">
                      {project.category}
                    </span>
                    <span className="text-sm text-gray-400">
                      {project.year}
                    </span>
                  </div>
                  
                  <h3 className="text-xl font-medium text-gray-900 mb-3 group-hover:text-gray-700 transition-colors">
                    {project.title}
                  </h3>
                  
                  <p className="text-gray-600 leading-relaxed">
                    {project.description}
                  </p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedWork;